import { TreeNode } from 'primeng/api';

export function updateNodeLoading(nodes: TreeNode[], nodeKey: string, loading: boolean): TreeNode[] {
  return nodes.map((node) => {
    if (node.key === nodeKey) {
      return { ...node, loading };
    }
    if (node.children) {
      return { ...node, children: updateNodeLoading(node.children, nodeKey, loading) };
    }
    return node;
  });
}

export function getLevelsState(node, data): { level: number; continue: boolean }[] {
  const levels: { level: number; continue: boolean; ref: any }[] = [];
  let current = node.parent;
  let level = node.level - 1;

  while (current && level >= 0) {
    const siblings = current.parent?.children || data;
    const index = siblings.findIndex((s) => s.key === current.key);
    const isLast = index === siblings.length - 1;

    levels.unshift({ level, continue: !isLast, ref: current });
    current = current.parent;
    level--;
  }

  for (let i = 0; i < levels.length - 1; i++) {
    const current = levels[i];
    const next = levels[i + 1];
    const hasDeeperChildren = next.ref?.children?.some((child) => child.children?.length > 0);

    if (!next.continue && !hasDeeperChildren) {
      current.continue = false;
    }
    if (next.continue && next.ref?.children?.length > 0) {
      current.continue = true;
    }
  }

  if (levels.length > 0 && levels[0].level === 0) {
    const rootSiblings = data;
    const rootNode = levels[0].ref;
    const index = rootSiblings.findIndex((s) => s.key === rootNode?.key);
    const isOnlyRootNode = rootSiblings.length === 1;
    const isLastRoot = index === rootSiblings.length - 1;
    const hasVisibleAfter = rootSiblings.slice(index).some((n) => n.expanded || n.children?.length > 0);
    levels[0].continue = !isOnlyRootNode && !isLastRoot && hasVisibleAfter;
  }
  return levels.map(({ level, continue: cont }) => ({ level, continue: cont }));
}
